import { Box, Typography, Rating, Divider } from "@mui/material";

export default function ReviewsTab() {
  const reviews = [
    { name: "Raj", rating: 5, comment: "Amazing course! Very well explained." },
    { name: "Simran", rating: 4, comment: "Good content, loved the examples." },
  ];

  return (
    <Box>
      <Typography variant="h6" mb={1}>Student Reviews</Typography>

      {reviews.map((rev, idx) => (
        <Box key={idx} mb={2}>
          <Typography fontWeight={600}>{rev.name}</Typography>
          <Rating value={rev.rating} readOnly size="small" />
          <Typography fontSize={14} color="text.secondary">{rev.comment}</Typography>
          <Divider sx={{ my: 1 }} />
        </Box>
      ))}
    </Box>
  );
}
